<template>
	<v-container>
			<div class="base-page">
				<logo-with-title :title = "$t('forgotPasswordPage.resetPassword')"/>
				<v-form
							ref="form"
							method="POST"
							action="/reset-password"
						>
							<input
								type="hidden"
								name="_token"
								:value="csrf"
							>
							<input
								type="hidden"
								name="token"
								:value="token"
							>
							<v-card-text>
								<smart-input
									v-model="form.email"
									class="base-input"
									:required="true"
									name="email"
									:label="$t('email')"
									:errors="errors.email"
									type="email"
								/>
								<smart-input
									id="password"
									v-model="form.password"
									class="base-input"
									required
									name="password"
									:label="$t('password')"
									minlength="6"
									:errors="errors.password"
									type="password"
								/>
								<smart-input
									id="confirm_password"
									v-model="form.password_confirmation"
									class="base-input"
									required
									name="password_confirmation"
									:label="$t('confirmPassword')"
									minlength="6"
									:errors="errors.password_confirmation"
									type="password"
								/>
							</v-card-text>
							<v-row justify="center">
								<v-col>
									<v-alert
										v-if="showErrors"
										dense
										outlined
										type="error"
									>
										<p
											v-for="(error,index) in errorBag"
											:key="error+index"
										>
											{{ error.toString() }}
										</p>
									</v-alert>
								</v-col>
							</v-row>
							<v-card-actions class="d-flex flex-column mt-8">
								<v-row>
									<v-col>
										<v-btn
											type="submit" block color="btnColor" rounded>
											{{$t('forgotPasswordPage.resetPassword')}}
										</v-btn>
									</v-col>
								</v-row>
							</v-card-actions>
						</v-form>
				<lang-select />
			</div>
	</v-container>
</template>

<script>
import LangSelect from "../../components/LangSelect.vue";
import LogoWithTitle from "@/components/LogoWithTitle";

export default {
	name: "ResetPassword",
	components: { LogoWithTitle, LangSelect },
	props: {
		admin: {
			type: Boolean,
		},
	},
	data: () => ({
		showError: false,
		disabled: false,
		form: {
			email: "",
			password: "",
			password_confirmation: "",
		},
		errors: {},
	}),
	computed: {
		csrf () {
			return document.querySelector("meta[name=csrf-token]").getAttribute("content");
		},
		token () {
			return this.$route.params.token;
		},
		errorBag () {
			return window.errorsBag;
		},
		showErrors () {
			return (Object.values(this.errorBag).length > 0 || (this.errorBag && this.errorBag.length > 0));
		},
	},
	created () {
		this.form.email = this.$route.query.email;
	},
};
</script>

<style lang="scss" scoped>
</style>
